// Google Sheets Integration
// =========================

// NOVÝ KÓD PRO GOOGLE APPS SCRIPT - bez setHeaders():
// ====================================================
/*
function doPost(e) {
  try {
    // Parse JSON data
    var data = JSON.parse(e.postData.contents);
    
    // Open spreadsheet - POUŽIJTE VAŠE SPREADSHEET ID
    var ss = SpreadsheetApp.openById('1V4koSoh6sExGZ8N55ctTAyccoOgRYaMMC9fRAGLrO9o');
    var sheet = ss.getSheetByName('Odpovědi');
    
    // Create sheet if doesn't exist
    if (!sheet) {
      sheet = ss.insertSheet('Odpovědi');
      sheet.appendRow(['Datum', 'Typ formuláře', 'Balíček', 'Název firmy', 'Velikost', 'URL webu', 'Email', 'Popis']);
    }
    
    // Add row
    var timestamp = new Date();
    sheet.appendRow([
      timestamp,
      data.formType || 'audit',
      data.packageName || '',
      data.companyName || '',
      data.companySize || '',
      data.websiteUrl || '',
      data.email || '',
      data.description || ''
    ]);
    
    // Send email notification
    try {
      var subject = 'Nová žádost z AI Optimalizace - ' + (data.packageName || 'Audit');
      var body = 'Nová odpověď byla přijata:\n\n' +
        'Typ: ' + (data.formType || 'audit') + '\n' +
        'Balíček: ' + (data.packageName || 'Neuveden') + '\n' +
        'Firma: ' + (data.companyName || 'Neuvedena') + '\n' +
        'Velikost: ' + (data.companySize || 'Neuvedena') + '\n' +
        'Web: ' + (data.websiteUrl || 'Neuveden') + '\n' +
        'Email: ' + (data.email || 'Neuveden') + '\n' +
        'Popis: ' + (data.description || 'Neuveden');
      
      MailApp.sendEmail('simonsoucek99@gmail.com', subject, body);
    } catch (emailError) {
      console.log('Email error: ' + emailError);
    }
    
    // Return success - bez setHeaders!
    var output = ContentService.createTextOutput(JSON.stringify({
      'status': 'success',
      'message': 'Data uložena'
    }));
    output.setMimeType(ContentService.MimeType.JSON);
    return output;
    
  } catch (error) {
    var output = ContentService.createTextOutput(JSON.stringify({
      'status': 'error',
      'message': error.toString()
    }));
    output.setMimeType(ContentService.MimeType.JSON);
    return output;
  }
}

function doGet(e) {
  var output = ContentService.createTextOutput(JSON.stringify({
    'status': 'ok',
    'message': 'Web App is running'
  }));
  output.setMimeType(ContentService.MimeType.JSON);
  return output;
}
*/

// GOOGLE APPS SCRIPT WEB APP URL
const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbydx5gL4NWX1Z_n_EHRltDlnWEAcrGRa2HUAlVep7Wh260R986oDJT4qODnaD2hvlqZ/exec';

interface FormData {
  companyName: string;
  companySize: string;
  websiteUrl: string;
  description: string;
  email: string;
  packageName?: string;
  formType: 'audit' | 'start' | 'rust' | 'premium' | 'newsletter';
}

/**
 * Odešle data do Google Sheets
 */
export const submitToGoogleSheets = async (data: FormData): Promise<boolean> => {
  try {
    // Použijeme no-cors mode pro obejítí CORS
    await fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    // V no-cors mode nemůžeme číst odpověď, ale předpokládáme úspěch
    // Data se zároveň uloží do localStorage jako záloha
    saveToLocalStorage(data);
    return true;
  } catch (error) {
    console.error('Chyba při odesílání:', error);
    // Uložíme lokálně jako zálohu
    saveToLocalStorage(data);
    return true;
  }
};

/**
 * Uloží data do localStorage jako zálohu
 */
const saveToLocalStorage = (data: FormData): void => {
  try {
    const submissions = JSON.parse(localStorage.getItem('form_submissions') || '[]');
    submissions.push({
      ...data,
      timestamp: new Date().toISOString(),
    });
    localStorage.setItem('form_submissions', JSON.stringify(submissions));
    console.log('Data uložena do localStorage:', data);
  } catch (error) {
    console.error('Chyba při ukládání do localStorage:', error);
  }
};

/**
 * Uloží newsletter email
 */
export const saveNewsletterEmail = async (email: string): Promise<boolean> => {
  try {
    // Uložit do localStorage
    const emails = JSON.parse(localStorage.getItem('newsletter_emails') || '[]');
    if (!emails.find((e: any) => e.email === email)) {
      emails.push({
        email,
        date: new Date().toISOString(),
        source: window.location.href
      });
      localStorage.setItem('newsletter_emails', JSON.stringify(emails));
    }

    // Odeslat do Google Sheets
    await submitToGoogleSheets({
      companyName: '',
      companySize: '',
      websiteUrl: '',
      description: '',
      email: email,
      formType: 'newsletter',
      packageName: 'Newsletter',
    });

    return true;
  } catch (error) {
    console.error('Chyba:', error);
    return false;
  }
};

/**
 * Export dat pro administrátora
 */
export const exportAllData = (): { submissions: any[]; emails: any[] } => {
  const submissions = JSON.parse(localStorage.getItem('form_submissions') || '[]');
  const emails = JSON.parse(localStorage.getItem('newsletter_emails') || '[]');
  return { submissions, emails };
};

export default {
  submitToGoogleSheets,
  saveNewsletterEmail,
  exportAllData,
  GOOGLE_SCRIPT_URL,
};
